<template>
<div id="app" class="home page-template-default page page-id-13 wp-custom-logo wp-embed-responsive post-image-aligned-center sticky-menu-fade sticky-enabled both-sticky-menu no-sidebar nav-below-header separate-containers header-aligned-left dropdown-hover">
  <HeadNav selectedLanguage="en" page="og"
      :gotodownload="gotodownload"
      :apk="apk" />

  <!-- 首屏独立于 .container，横向铺满视口 -->
  <OgHomeHero />
  <!-- 参照 gbmodshub 式中层：双卡片 / 功能深色带 / 简介表 -->
  <OgHomeSpotlight />

  <div id="page" class="site container hfeed">
    <div id="content" class="site-content">
      <div id="primary" class="content-area">
        <main id="maincontent" class="site-main site-main--og-home">
          <OgHomeArticle />
          <section class="og-faq-section inside-article section-content" aria-labelledby="faq-heading">
            <h2 id="faq-heading" class="faq-section-title">
Frequently Asked Questions
</h2>
            <FAQ :faqs="homeFaqs" />
          </section>
        </main>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import FAQ from '@/components/FAQ.vue';
import OgHomeHero from '@/views/partials/OgHomeHero.vue';
import OgHomeSpotlight from '@/views/partials/OgHomeSpotlight.vue';
import OgHomeArticle from '@/views/partials/OgHomeArticle.vue';
import homeFaqs from '@/content/ogHomeFaqs.js';
import 'swiper/css/swiper.css';

export default {
  name: 'Home',
  components: {
    HeadNav,
    FAQ,
    OgHomeHero,
    OgHomeSpotlight,
    OgHomeArticle,
  },
  data() {
    return {
      pageName: 'home',
      tableHide: true,
      comment: {
        name: '',
        email: '',
        content: '',
      },
      showapk: false,
      showTableOfContents: false,

      apk: null,
      from: 'gb',
      filename: 'gb',
      clickNum: 0,
      selectedLanguage: 'en',
      homeFaqs,
    };
  },
  computed: {
    downloadURL() {
      if (typeof window === 'undefined') {
        return '/download/';
      } else {
        let params = window.location.search;
        return `/download/${params}`;
      }
    },
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {
    downloadClick() {
      this.$router.push({
        name: 'en-download'
      });
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
    },
    gotoblog() {
      window.location.href = '/blogs';
    },
    jump(url) {
      window.location.href = url;
    },

  },
};
</script>

<style scoped>
/* 首页根节点拉满视口宽，避免首屏与容器叠层出现侧缝 */
.home {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

/* 首页首屏与正文衔接：减少 main 顶部空隙 */
.site-main--og-home {
  padding-top: 0 !important;
}

.faq-section-title {
  margin-top: 2.5rem;
  margin-bottom: 0.75rem;
  font-size: clamp(1.45rem, 3vw, 1.75rem);
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #ffffff;
  line-height: 1.25;
  padding: 0.7rem 1rem 0.75rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #204f46 0%, #2a6b5c 100%);
  box-shadow: 0 6px 20px rgba(32, 79, 70, 0.22);
}

.faq-section-title::after {
  display: none;
}
/* FAQ 与正文、首屏同宽；覆盖全局 .section-content 宽度限制 */
.og-faq-section.inside-article.section-content {
  width: 100% !important;
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 max(16px, env(safe-area-inset-right)) 48px max(16px, env(safe-area-inset-left));
  box-sizing: border-box;
}
</style>
